// extracted by mini-css-extract-plugin
module.exports = {"spinner":"XdsButton_spinner__y91D0"};